import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type AbilitiesService from 'ember-can/services/abilities';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type StatsigService from 'garaje/services/statsig';
import type WorkplaceMetricsService from 'garaje/services/workplace-metrics';

export default class WelcomeChecklistComponent extends Component {
  @service declare flashMessages: FlashMessagesService;
  @service declare statsig: StatsigService;
  @service declare abilities: AbilitiesService;
  @service declare workplaceMetrics: WorkplaceMetricsService;

  @action
  logEvent(event_name: string): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.statsig.logEvent(event_name);
    this.workplaceMetrics.trackEvent(`WORKPLACE_SETUP_GUIDE_${event_name.toLocaleUpperCase()}`);
  }
}
